const initialTokensValues = {
  'color-button-text': '#FFF',
  'color-detached': '#044B97',
  'color-detached-lighter': '#066ddc',
  'color-background': '#2a67be',
  'color-highlight': '#2a67be',
  'color-highlight-lighter': '#2a67be',
  'color-highlight-darker': '#2a67be',
  'color-border': '#DDDDDD',
  'color-neutral-dark': '#59585A',
  'color-neutral-dark-lighter': '#979AA3',
  'color-neutral-dark-darker': '#1E1D1E',
  'color-neutral-light': '#B9BEC9',
  'color-neutral-light-lighter': '#FAF6F8',
  'color-neutral-light-darker': '#D6D6E6',
  'spacing-small': '16px',
  'spacing-regular': '24px',
  'spacing-big': '32px',
  'spacing-extra-big': '40px',
  'spacing-giant': '120px',
  'border-width': '1px',
  'border-radius-primary': '8px',
  'border-radius-secondary': '8px',
  'font-giant': '22px',
  'font-big': '18px',
  'font-medium': '16px',
  'font-paragraph': '14px',
  'font-paragraph-line': '150%',
  'font-small': '12px',
  'font-family': "'Poppins', sans-serif",
  'form-item-height': '48px',
  'form-item-height-lg': '56px',
  fontSizeIcon: 12,
  favicon: 'https://vertem.com/wp-content/uploads/2021/05/favicon-1.png',
  'banners-like-mais':
    '{"2":{"desktopUrl":"https://vertice-ds.s3.amazonaws.com/Assets/Images/LikePlus/banner-syngenta-cartao-desktop-min.png","mobileUrl":"https://vertice-ds.s3.amazonaws.com/Assets/Images/LikePlus/banner-syngenta-cartao-mobile-min.png","tabletUrl":"https://vertice-ds.s3.amazonaws.com/Assets/Images/LikePlus/banner-syngenta-cartao-tablet-min.png","alt":"Ilustração cartão."},"default":{"desktopUrl":"https://vertice-ds.s3.amazonaws.com/Assets/Images/LikePlus/banner-syngenta-casal-desktop-min.png","mobileUrl":"https://vertice-ds.s3.amazonaws.com/Assets/Images/LikePlus/banner-syngenta-casal-mobile-min.png","tabletUrl":"https://vertice-ds.s3.amazonaws.com/Assets/Images/LikePlus/banner-syngenta-casal-tablet-min.png","alt":"Mulher com cartão like mais."},"2-hasCard":{"desktopUrl":"https://vertice-ds.s3.amazonaws.com/Assets/Images/LikePlus/banner-syngenta-cartao-desktop-min.png","mobileUrl":"https://vertice-ds.s3.amazonaws.com/Assets/Images/LikePlus/banner-syngenta-cartao-mobile-min.png","tabletUrl":"https://vertice-ds.s3.amazonaws.com/Assets/Images/LikePlus/banner-syngenta-cartao-tablet-min.png","alt":"Ilustração cartão."},"default-hasCard":{"desktopUrl":"https://vertice-ds.s3.amazonaws.com/Assets/Images/LikePlus/banner-syngenta-cartao-desktop-min.png","mobileUrl":"https://vertice-ds.s3.amazonaws.com/Assets/Images/LikePlus/banner-syngenta-cartao-mobile-min.png","tabletUrl":"https://vertice-ds.s3.amazonaws.com/Assets/Images/LikePlus/banner-syngenta-cartao-tablet-min.png","alt":"Mulher com cartão like mais."}}',
  logotipo:
    'https://premmiardev.blob.core.windows.net/redemptions-files/324e30a3-7395-45a1-8675-b9839decf94a.png',
  'logotipo-footer':
    'https://premmiardev.blob.core.windows.net/redemptions-files/324e30a3-7395-45a1-8675-b9839decf94a.png',
  'header-color-background': '#00183A',
  'header-color-menu-text': '#FFFFFF',
  'header-color-icon-participant-info': '#FFFFFF',
  'header-color-search-icon': '#003778',
  'header-color-points-content': '#FFFFFF',
  'header-color-search-button': '#FFFFFF',
  'header-color-search-button-hover': '#FFFFFF',
  'header-color-close-button-responsive': '#00183A',
  'header-color-points-border': '#FFFFFF',
  'header-color-menu-dropdown': '#FFFFFF',
  'header-color-menu-text-points': '#FFFFFF',
  'footer-color-button-text': '#FFFFFF',
  'footer-color-background': '#00183A',
  'footer-size-logo-maxwidth': '300px',
  'footer-size-logo-maxheight': '110px',
  'footer-size-logo-maxwidth-mobile-md': '300px',
  'footer-size-logo-maxwidth-mobile-sm': '200px',
  'header-color-menu-text-hover': '#FFFFFF',
  'header-color-menu-text-active': '#FFFFFF',
  'header-color-border-search-button': '#FFFFFF',
  'color-detached-super-lighter': '#d8e8ff',
  'color-highlight-super-lighter': '#d8e8ff',
  'footer-logo-object-fit': 'cover',
  'footer-logo-box-sizing': 'border-box',
  'header-color-icon-dollar-responsive': '#ffffff',
};

export default initialTokensValues;
